import request from '@/libs/request';

export const unBindingDoctorApi = (data) =>
  request('api/doctorPortrait/manager/unBindingDoctor', data);
export const exportUnBindingDoctorApi = (data) =>
  request('api/doctorPortrait/manager/exportUnBindingDoctor', data);
// 获取医生列表
export const getDoctorListApi = (data) => request('GetDoctorList', data);
// 获取代表搜索列表
export const getRepresentativeListApi = (data) => request('ListRepresentative', data);
// 获取代表详情信息
export const getRepresentativeDetailInfoApi = (data) => request('GetRepresentativeDetail', data);
// 代表详情管理医生列表
export const ListRepresentativeDoctorApi = (data) => request('ListRepresentativeDoctor', data);

// 医生关系链
export const relationChainPagesApi = (data) => request('DoctorRelation', data);
// 医生参会详情
export const meetingInfoPagesApi = (data) => request('DoctorMeetingInfo', data);
// 医生阅读详情
export const readInfoPagesApi = (data) => request('DoctorReadingInfo', data);

// 获取医院列表
export const queryPagesApi = (data) => request('GetHospitalList', data);
// 获取区域列表
export const getAreaList = (data = {}) => request('GetAreaList', data);
// 获取科室与职称
// 不要用下面这个QueryHospitalDepartment方法！不要盲目复制使用该接口的代码！
export const QueryHospitalDepartment = (url, data = {}) => request(url, data);
export const QueryTitleList = (data = {}) => request('QueryTitleList', data);
export const getHospitalDepartmentListApi = (data = {}) => request('QueryHospitalDepartment', data);
// 获取医生等级或性别
export const GetKvList = (data = {}) => request('GetKvList', data);
